export default {"src":"/_next/static/media/mobile-cart-icon.bf49cf57.svg","height":19,"width":23,"blurWidth":0,"blurHeight":0};